export const readAsDataUrlAsync = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => resolve(reader.result)
  reader.onerror = () => reject(reader.error)
  reader.readAsDataURL(blob)
})

export const readFileAsync = async(file) => ({ name: file.name, payload: await readAsDataUrlAsync(file) })
